import { AuthenticationData } from '@directus/sdk';

export const checkDirectusAuthentication = async() => {
	const directusDataString = localStorage.getItem('directus-data');
	if(!directusDataString) return Promise.reject('koekje');
	const directusDataParsed : AuthenticationData = JSON.parse(directusDataString);
	if(!directusDataParsed.access_token || !directusDataParsed.expires_at || !directusDataParsed.refresh_token) return Promise.reject('groot kokei');
};